import styled from 'styled-components'

const StepItemImage = styled.img`
  height: 100%;
  object-fit: cover;
  margin-right: ${({ theme }) => theme.spacing.small};
`

export default StepItemImage
